const auth = {
  enterPhoneNumber: 'Введите номер телефона',
  confirmationCode: 'Код подтверждения',
  enterConfirmationCode: 'Введите код подтверждения',
  getCode: 'Получить код',
  resendCode: 'Отправить код еще раз',
  resendCodeAfter: 'Отправить еще код через',
  enterCodeFromSms: 'Мы отправили код в ваш Telegram на номер ',
  signIn: 'Войти',
  signOut: 'Выйти',
  password: 'Пароль',
};

export default auth;
